/* Brand testimonials slider — pairs with section 23 in brand-mobile-cro.css.
   Wires prev/next buttons + dot indicators for any
   .testimonials-slider-block on the page. No dependencies. */
(function () {
  function init(block) {
    var track = block.querySelector('.testimonials-slider__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.testimonials-slide'));
    if (slides.length === 0) return;
    var id = block.getAttribute('data-slider-id');
    var prev = block.querySelector('[data-slider-prev="' + id + '"]');
    var next = block.querySelector('[data-slider-next="' + id + '"]');
    var dotsWrap = block.querySelector('[data-slider-dots="' + id + '"]');

    // Build dot indicators
    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials-slider__dot' + (i === 0 ? ' testimonials-slider__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function currentIndex() {
      var slideWidth = slides[0].getBoundingClientRect().width + 12; // gap
      return Math.round(track.scrollLeft / slideWidth);
    }

    function scrollToIndex(i) {
      var clamped = Math.max(0, Math.min(slides.length - 1, i));
      slides[clamped].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    function updateDots() {
      if (!dotsWrap) return;
      var i = currentIndex();
      var dots = dotsWrap.querySelectorAll('.testimonials-slider__dot');
      dots.forEach(function (d, idx) {
        d.classList.toggle('testimonials-slider__dot--active', idx === i);
      });
    }

    if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });

    var rafId = null;
    track.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateDots);
    }, { passive: true });

    // Reset to slide 0 on init
    updateDots();
  }

  function initAll() {
    document.querySelectorAll('.testimonials-slider-block').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
